import "~/app/sentry";
import "@fontsource/nunito-sans/400.css";
import "@fontsource/nunito-sans/600.css";
import "@fontsource/nunito-sans/700.css";
import "~/app/styles/globals.css";
import "~/app/storage-migration";

import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { App } from "~/app/App";

document.documentElement.classList.add("dark");

createRoot(document.getElementById("root")!).render(
    <StrictMode>
        <App />
    </StrictMode>,
);
